import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import axiosRequestInterceptor from "../interceptor/axiosAPIRequestInterceptor";

const PLAN_SUBHEADINGS = {
	FREE_TIER: "Functionality Overview",
	QUICK_PREP: "Short-Term Access Plan",
	GUIDED_LEARNER: "Quarterly Plan",
	PEAK_PREP: "Annual Plan",
};

const PLAN_COLORS = {
	FREE_TIER: "#FFFDFD",
	QUICK_PREP: "#545454",
	GUIDED_LEARNER: "#2355F5",
	PEAK_PREP: "#08BD80",
};

export const usePricingPlans = () => {

	const [pricingPlans, setPricingPlans] = useState([]);
	const [isLoading, setIsLoading] = useState(true);
	const [error, setError] = useState(null);

	useEffect(() => {
		fetchPricingData();
	}, []);

  const fetchPricingData = async () => {
    try {
      const response = await axiosRequestInterceptor.post(`users/pricingDetails`);
      
      
      const formattedPlans = formatPricingPlans(response.data.pricingDetails);
      setPricingPlans(formattedPlans);
    } catch (err) {
      setError('Failed to load pricing plans');
    } finally {
      setIsLoading(false);
    }
  };

  const extractFirstSetOfWords = (inputArray) =>{
    return inputArray.map(item => {
        let parts = item.split(':');
        return parts[0].trim();
    });
}

  const formatPricingPlans = (plans) => {
    return plans.map(plan => ({
      id: plan.TIER_ID,
      heading: plan.TIER_NAME,
      subHeading: PLAN_SUBHEADINGS[plan.TIER_ID],
      oldPriceLabel: formatOldPrice(plan.PRICE),
      discount: plan.DISCOUNT,
      newPrice: plan.PRICE - (plan.PRICE * plan.DISCOUNT) / 100,
      amountLabel: formatAmount((plan.PRICE - (plan.PRICE * plan.DISCOUNT) / 100), plan.DISCOUNT),
      planType: plan.PRIORITY_NO - 1,
      bgColor: PLAN_COLORS[plan.TIER_ID],
      features: plan.FEATURES,
      featuresShort: extractFirstSetOfWords(plan.FEATURES),
      limitations: plan.LIMITATIONS,
      planTierId: plan.TIER_ID,
      stripePriceId: plan.STRIPE_PRICE_ID,
    }));
  };

  const formatAmount = (price, discount) => {
    if (price === 0) return "$ 0";
    return `$${price} ${discount > 0 ? `@${discount}% Discount` : ''}`;
  };

  const formatOldPrice = (price) => {
    if (price === 0) return "$ 0 ";
    return `$${price} `;
  };

	return { pricingPlans, isLoading, error };
};
